import React from 'react'
// import VideoModal from '../ModalVideo'
import './style.css'
import abimg from '../../images/founder.jpg'

const Founder = (props) => {
  return (
    <div className="wpo-about-area section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 colsm-12">
            <div className="wpo-about-text">
              <div className="wpo-section-title">
                {/* <span>What We Do?</span> */}
                <h2>About The Founder</h2>
              </div>
              <p>Minangka Deka is a distinguished mime artist celebrated for his exceptional talent and unwavering dedication to the art of mime. He was honored with the Senior Scholarship for Mime by the Ministry of Culture, Government of India, in 2018, and also received the prestigious Young Talented Artist Award for Mime from the North East Zone Cultural Centre (NEZCC), Ministry of Culture, Government of India.
              </p>
              <p>As the visionary leader of Nirbaak, a dynamic social and cultural organization based in Assam, Minangka has been at the forefront of promoting mime since 2018. Under his guidance, Nirbaak has launched impactful initiatives, including engaging street performances that highlight critical social issues and the pioneering celebration of World Mime Day in Assam.
              </p>
              <p>Collaborating closely with various government departments, Nirbaak has created powerful mime presentations addressing a wide spectrum of topics such as AIDS, COVID-19, cancer, HIV, cybercrime, child marriage, cleanliness drives (Swachata), road safety, drug abuse, and environmental conservation efforts, including the protection of Deepor Beel—a renowned Ramsar Convention wetland.</p>
              <p>Beyond performances, Nirbaak's commitment to the art extends to publishing India's first international mime journal, also named Nirbaak, further solidifying its role as a key platform for advancing and celebrating mime culture.</p>
              <p>Through Minangka Deka's leadership, Nirbaak continues to transform the silent art of mime into a profound voice for awareness, education, and social change.</p>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 colsm-12">
            <div className="wpo-about-img-3">
              <img src={abimg} alt="" />
            </div>
          </div>
        </div>
      </div>
      
    </div>

    
  )
}

export default Founder;